import { PosteffectsConfigDto } from '../../../../trillion-common/src/dto/posteffects-config.dto'
import { ViewerConfig } from '../../../../trillion-common/src/objects/viewer-config.object'
import { WidgetConfig } from '../../../../trillion-common/src/objects/widget-config.object'
import { StoreScheme } from '../../shared/store/store'
import { SceneLight } from '../types/scene-light'
import { createConfigFromLight } from './createConfigFromLight'
import { ReflectionMapDto } from '../../../../trillion-common/src/dto/reflection-map.dto'

export function saveConfigs(lights: SceneLight[], store: StoreScheme) {
  const pointsOfView = store.getState().pointsOfView

  const posteffectsConfig = {
    bloom: store.getState().bloom,
    bloomSelective: { ...store.getState().bloomSelective, selectiveNames: ['Diamond'] },
    depthOfField: store.getState().depthOfField,
    smaa: store.getState().smaa,
    ssao: store.getState().ssao,
    n8ao: store.getState().n8ao,
    textureMapping: store.getState().textureMapping,
    toneMapping: store.getState().toneMapping,
  } as PosteffectsConfigDto

  const cameraRotation = {
    autoRotateSpeed: store.getState().autoRotateSpeed,
    freeMoveCamera: store.getState().isFreeMoveCameraModeEnabled,
    rotateObject: store.getState().rotateObject,
  }

  const selectedReflectionMap: ReflectionMapDto | undefined = store.getState().reflectionMap

  const setViewerConfig = store.getState().setViewerConfig
  const setWidgetConfig = store.getState().setWidgetConfig

  const viewerCallback = store.getState().onViewerConfigSaved
  const widgetCallback = store.getState().onWidgetConfigSaved

  const viewerConfig = store.getState().viewerConfig
  const widgetConfig = store.getState().widgetConfig

  if (!viewerConfig || !widgetConfig) return

  const lightsConfig = lights.map(createConfigFromLight)
  const newViewerConfig = new ViewerConfig({
    ...viewerConfig,
    pointsOfView: pointsOfView,
    lights: lightsConfig,
    cameraRotation,
    posteffectsConfig,
    reflectionMap: selectedReflectionMap,
  })
  setViewerConfig(newViewerConfig)

  const newWidgetConfig = new WidgetConfig({
    ...widgetConfig,
    posteffectsConfig,
  })
  setWidgetConfig(newWidgetConfig)

  if (viewerCallback) {
    viewerCallback(newViewerConfig)
  }

  if (widgetCallback) {
    widgetCallback(newWidgetConfig)
  }
}
